import { transport, BASE_PATH } from "@/src/config/apiConfig.js";
import WorkspaceService from "@/src/api/WorkspaceService.js";

export default {
  getBasePath() {
    return BASE_PATH;
  },

  isDefined(val) {
    return typeof val !== "undefined" && val !== null;
  },

  async fetchCampaignTemplates() {
    try {
      let res = await transport.get(BASE_PATH + `/api/campaign_templates`, {
        params: {},
      });
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign templates:", error);
      throw error;
    }
  },

  async fetchCampaignTemplateDetails(template_id) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaign_templates/${template_id}`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign template details:", error);
      throw error;
    }
  },

  async saveCampaignTemplateDetails(template_id, offer, template_name) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaign_templates/save_template`,
        {
          offer: offer,
          template_id: template_id,
          template_name: template_name,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error saving campaign template details:", error);
      throw error;
    }
  },

  async deleteCampaignTemplate(template_id) {
    try {
      let res = await transport.delete(
        BASE_PATH + `/api/campaign_templates/${template_id}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error deleting campaign template:", error);
      throw error;
    }
  },

  async campaignFilters(field, query) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/filters/${field}`,
        {
          params: {
            query: query,
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign filters:", error);
      throw error;
    }
  },

  async campaignAllFilters(field, query, vendor) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/filters_all_options`,
        {
          params: {
            query: query,
            vendor: vendor,
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign all filters:", error);
      throw error;
    }
  },

  async saveFilter(campaign_id, icp, is_complete) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaign_id}/save_icp`,
        {
          icp: icp,
          is_complete: is_complete,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error saving filter:", error);
      throw error;
    }
  },

  async fetchCampaignIcps(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/fetch_icps`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign ICPs:", error);
      throw error;
    }
  },

  async fetchCampaignOffers(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/fetch_offers`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign offers:", error);
      throw error;
    }
  },

  async fetchCampaignSteps(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/fetch_steps`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign steps:", error);
      throw error;
    }
  },

  async fetchCampaignDetails(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign details:", error);
      throw error;
    }
  },

  async cloneCampaign(campaignId) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/clone`,
      );
      return res.data;
    } catch (error) {
      console.error("Error cloning campaign:", error);
      throw error;
    }
  },

  async saveEmailAccounts(campaignId, emailAccountData) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/email-accounts`,
        { campaign_email_accounts: emailAccountData },
      );
      return res.data;
    } catch (error) {
      console.error("Error saving email accounts:", error);
      throw error;
    }
  },

  async fetchCampaignEmailAccounts(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/email-accounts`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign email accounts:", error);
      throw error;
    }
  },

  async fetchSelectedCampaignEmailAccounts(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/selected-email-accounts`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching selected campaign email accounts:", error);
      throw error;
    }
  },

  async allCampaigns() {
    try {
      let res = await transport.get(BASE_PATH + "/api/all_campaigns", {
        params: {},
      });
      return res.data;
    } catch (error) {
      console.error("Error fetching all campaigns:", error);
      throw error;
    }
  },

  async fetchCampaigns(page, pageSize, searchQuery, statusFilters, dateFilter) {
    try {
      let params = {
        page: page,
        page_size: pageSize,
        search: searchQuery,
        created_date: dateFilter,
      };

      if (statusFilters?.length > 0) {
        params.statuses = statusFilters;
      }

      let res = await transport.get(BASE_PATH + "/api/campaigns", {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      throw error;
    }
  },

  async fetchCampaignLeads(campaignId, page, page_size, statusFilter) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/leads`,
        {
          params: {
            page: page,
            page_size: page_size,
            status: statusFilter,
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign leads:", error);
      throw error;
    }
  },

  async fetchRepliedLeads(page, page_size, campaign_ids, campaign_categories) {
    try {
      let params = {
        page: page,
        page_size: page_size,
      };

      if (campaign_ids?.length > 0) {
        params.campaign_ids = campaign_ids;
      }

      if (campaign_categories?.length > 0) {
        params.campaign_categories = campaign_categories;
      }

      let res = await transport.get(
        BASE_PATH + `/api/campaigns/replied_leads`,
        {
          params: params,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching replied leads:", error);
      throw error;
    }
  },

  async fetchCampaignLeadDetail(campaignId, leadId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/lead_details`,
        {
          params: {
            lead_id: leadId,
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign lead detail:", error);
      throw error;
    }
  },
  async regenerateCampaignLeadStep(campaignId, leadId, campaignStepId) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/regenerate_step`,
        {
          lead_id: leadId,
          campaign_step_id: campaignStepId,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error regenerating campaign lead step:", error);
      throw error;
    }
  },
  async saveCampaignLeadSteps(campaignId, leadId, steps_data) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/save_lead_steps`,
        {
          lead_id: leadId,
          steps_data: steps_data,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error saving campaign lead steps:", error);
      throw error;
    }
  },

  async createCampaign(campaignData) {
    try {
      let res = await transport.post(
        BASE_PATH + "/api/campaigns",
        campaignData,
      );
      return res.data;
    } catch (error) {
      console.error("Error creating campaign:", error);
      throw error;
    }
  },

  async saveOffer(campaignId, offerData, templateId) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/save_offer`,
        {
          offer: offerData,
          template_id: templateId,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error saving offer:", error);
      throw error;
    }
  },

  async saveSteps(campaignId, is_personalized, subject, steps, move_to_next) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/save_steps`,
        {
          is_personalized: is_personalized,
          subject: subject,
          steps: steps,
          move_to_next: move_to_next,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error saving steps:", error);
      throw error;
    }
  },

  async saveSettings(campaignId, settings, shouldContinue) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/save_settings`,
        {
          settings: settings,
          start_campaign: shouldContinue,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error saving settings:", error);
      throw error;
    }
  },

  async fetchSettings(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/fetch_settings`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching settings:", error);
      throw error;
    }
  },

  async updateCampaign(campaignId, campaignData) {
    try {
      let res = await transport.put(
        BASE_PATH + `/api/campaigns/${campaignId}`,
        campaignData,
      );
      return res.data;
    } catch (error) {
      console.error("Error updating campaign:", error);
      throw error;
    }
  },

  async deleteCampaign(campaignId) {
    try {
      let res = await transport.delete(
        BASE_PATH + `/api/campaigns/delete/${campaignId}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error deleting campaign:", error);
      throw error;
    }
  },

  async fetchCampaignAnalytics(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/analytics`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign analytics:", error);
      throw error;
    }
  },

  async getCampaignChartData(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/chart_data`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error getting campaign chart data:", error);
      throw error;
    }
  },

  async fetchNewCampaignAnalytics(campaignId, startDate, endDate) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/campaigns/${campaignId}/new_analytics`,
        {
          params: {
            start_date: startDate,
            end_date: endDate,
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching new campaign analytics:", error);
      throw error;
    }
  },

  async fetchNewChartData(campaignId, startDate, endDate) {
    try {
      let res = await transport.get(
        `${BASE_PATH}/api/campaigns/${campaignId}/new_chart_data`,
        {
          params: {
            start_date: startDate,
            end_date: endDate,
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching new chart data:", error);
      throw error;
    }
  },
  async fetchPreviewLeads(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/preview_leads`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching preview leads:", error);
      throw error;
    }
  },

  async generateStep(campaignId, steps, step_type, subject, index) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/generate_step`,
        {
          steps: steps,
          step_type: step_type,
          subject: subject,
          index: index,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error generating step:", error);
      throw error;
    }
  },
  async regenerateStepWithComment(
    campaignId,
    steps,
    step_type,
    subject,
    body,
    comment,
  ) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/regenerate_step_with_comment`,
        {
          steps: steps,
          step_type: step_type,
          subject: subject,
          body: body,
          comment: comment,
        },
      );

      return res.data;
    } catch (error) {
      console.error("Error regenerating step with comment:", error);
      throw error;
    }
  },

  async getSenderDetails() {
    try {
      let res = await transport.get(BASE_PATH + `/api/sender_detail`);
      return res.data;
    } catch (error) {
      console.error("Error getting sender details:", error);
      throw error;
    }
  },

  async approveExecution(campaignId, leadId) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/approve_execution`,
        { campaign_id: campaignId, lead_id: leadId },
      );
      return res.data;
    } catch (error) {
      console.error("Error approving execution:", error);
      throw error;
    }
  },
  async removeLeadFromCampaign(campaignId, leadId) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/remove_lead`,
        { lead_id: leadId },
      );
      return res.data;
    } catch (error) {
      console.error("Error removing lead from campaign:", error);
      throw error;
    }
  },
  async endCampaign(campaignId) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/end_campaign`,
        {},
      );
      return res.data;
    } catch (error) {
      console.error("Error ending campaign:", error);
      throw error;
    }
  },
  async resumeCampaign(campaignId) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/resume_campaign`,
        {},
      );
      return res.data;
    } catch (error) {
      console.error("Error resuming campaign:", error);
      throw error;
    }
  },
  async pauseCampaign(campaignId) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/pause_campaign`,
        {},
      );
      return res.data;
    } catch (error) {
      console.error("Error pausing campaign:", error);
      throw error;
    }
  },

  async createCampaignList(campaignId, payload) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/campaign_list`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error creating campaign list:", error);
      throw error;
    }
  },

  async getCampaignListFileName(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/file_name`,
      );
      return res.data;
    } catch (error) {
      console.error("Error getting campaign list file name:", error);
      throw error;
    }
  },

  async fetchLeadsPreviewCampaignList(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/preview_list/${campaignId}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching leads preview campaign list:", error);
      throw error;
    }
  },

  async updateCampaignList(campaignId, payload) {
    try {
      let res = await transport.put(
        BASE_PATH + `/api/campaigns/${campaignId}/campaign_list`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error updating campaign list:", error);
      throw error;
    }
  },

  async saveCampaignTriggerAndCriteria(campaignId, trigger, criteria) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/save_trigger`,
        {
          trigger: trigger,
          criteria: criteria,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error saving campaign trigger and criteria:", error);
      throw error;
    }
  },

  async fetchCampaignTriggerAndCriteria(campaignId) {
    try {
      let res = await transport.get(
        BASE_PATH + `/api/campaigns/${campaignId}/fetch_trigger`,
        {
          params: {},
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching campaign trigger and criteria:", error);
      throw error;
    }
  },

  async saveAddLeadStep(campaignId) {
    try {
      let res = await transport.put(
        BASE_PATH + `/api/campaigns/${campaignId}/save_leads`,
      );
      return res.data;
    } catch (error) {
      console.error("Error saving add lead step:", error);
      throw error;
    }
  },

  async saveLinkedinAccounts(campaignId, accountId) {
    try {
      let res = await transport.post(
        BASE_PATH + `/api/campaigns/${campaignId}/save_linkedin_accounts`,
        { id: campaignId, account_id: accountId },
      );
      return res.data;
    } catch (error) {
      console.error("Error saving LinkedIn accounts:", error);
      throw error;
    }
  },

  async fetchViews(entityType) {
    try {
      const res = await transport.get(
        BASE_PATH + `/api/outreach/${entityType}/views`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching views:", error);
      throw error;
    }
  },

  async updateView(viewId, data) {
    try {
      const res = await transport.put(
        BASE_PATH + `/api/outreach/views/${viewId}`,
        data,
      );
      return res.data;
    } catch (error) {
      console.error("Error updating view:", error);
      throw error;
    }
  },

  async deleteView(viewId) {
    try {
      const res = await transport.delete(
        BASE_PATH + `/api/outreach/views/${viewId}`,
      );
      return res.data;
    } catch (error) {
      console.error("Error deleting view:", error);
      throw error;
    }
  },

  async createNewView(data) {
    try {
      const res = await transport.post(BASE_PATH + `/api/outreach/views`, data);
      return res.data;
    } catch (error) {
      console.error("Error creating new view:", error);
      throw error;
    }
  },

  async updateCurrentView(viewId) {
    try {
      const res = await transport.put(
        BASE_PATH + `/api/outreach/views/${viewId}/current_view`,
      );
      return res.data;
    } catch (error) {
      console.error("Error updating current view:", error);
      throw error;
    }
  },

  async closeView(viewId) {
    try {
      const res = await transport.put(
        BASE_PATH + `/api/outreach/views/${viewId}/close`,
      );
      return res.data;
    } catch (error) {
      console.error("Error closing view:", error);
      throw error;
    }
  },

  async updateViewSequence(data) {
    try {
      const res = await transport.put(
        BASE_PATH + `/api/outreach/views/active_views`,
        data,
      );
      return res.data;
    } catch (error) {
      console.error("Error updating view sequence:", error);
      throw error;
    }
  },

  async fetchFilteredCampaigns(viewId, page, pageSize, searchQuery) {
    try {
      const res = await transport.get(
        `${BASE_PATH}/api/outreach/views/${viewId}/campaigns`,
        {
          params: {
            page_size: pageSize,
            page: page,
            search: searchQuery,
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching filtered campaigns:", error);
      throw error;
    }
  },

  async fetchFilteredReplies(viewId, page, pageSize, searchQuery) {
    try {
      const res = await transport.get(
        `${BASE_PATH}/api/outreach/views/${viewId}/replied_leads`,
        {
          params: {
            page_size: pageSize,
            page: page,
            search: searchQuery,
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching filtered replies:", error);
      throw error;
    }
  },

  async applyFilter(viewId, payload) {
    try {
      const res = await transport.put(
        `${BASE_PATH}/api/outreach/views/${viewId}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("Error applying filter:", error);
      throw error;
    }
  },

  async fetchViewSharingDetails(viewId) {
    try {
      const res = await transport.get(
        BASE_PATH + `/api/outreach/views/${viewId}/sharing`,
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching outreach view sharing details:", error);
      throw error;
    }
  },
};
